import { Rol } from "../../model/root/Rol";

const apiUrl = process.env.REACT_APP_API_URL;
export const PostRolDuplicar = async ( rol: Rol, page : string  ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/usuaris/rol/duplicar`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(rol)
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};